export default "__VITE_ASSET__DyrnBWpD__"